import { z } from 'zod';

import { attachmentSchema } from '../../attachments/schemas/attachment';
import { customerSchema } from '../../customer/schemas/customer';
import { userSchema } from '../../user/types';
import { commissionSchema } from './commission';
import { commissionDischargeSchema } from './commissionDischarge';
import { commissionEarlyPayStatusEnum } from './commissionEarlyPayStatus';
import { commissionExpectedLiabilitySchema } from './commissionExpectedLiability';
import { commissionItemSchema } from './commissionItem';
import { commissionLoadingSchema } from './commissionLoading';

// NOTE: invoice schema inlined (minimal identity shape) to avoid a circular
// import with `invoice/schemas/invoice.ts`, which itself imports from
// `'../../commission'`. Full invoice data is available via the invoice
// endpoints / `extendedInvoiceSchema` — this field just indicates linkage.
const invoiceRefSchema = z.object({
    invoice_id: z.number(),
    number: z.string(),
});

export const extendedCommissionSchema = commissionSchema.extend({
    earlyPayStatus: commissionEarlyPayStatusEnum,
    customer: customerSchema.nullable(),
    loadings: z.array(commissionLoadingSchema),
    discharges: z.array(commissionDischargeSchema),
    items: z.array(commissionItemSchema),
    vehicleFeatures: z
        .object({
            vehicleFeature_id: z.number(),
        })
        .array()
        .optional(),
    vehicleTypes: z
        .object({
            vehicleType_id: z.number(),
        })
        .array()
        .optional(),
    invoice: invoiceRefSchema.nullable(),
    addedBy: userSchema,
    carrierAssignedBy: userSchema.nullable(),
    firstLoading: commissionLoadingSchema.nullable(),
    lastDischarge: commissionDischargeSchema.nullable(),
    carrierInvoice: attachmentSchema.nullable(),
    expectedLiability: commissionExpectedLiabilitySchema.nullable(),
});
export type TExtendedCommission = z.infer<typeof extendedCommissionSchema>;
